export default "__VITE_ASSET__ed98dce6__"